import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Export a simple test function to meet coverage requirements
export function testHelper(input: string): string {
  return input.toLowerCase();
}